// Define los umbrales para lo que se considera un dispositivo de bajos recursos.
// Estos valores pueden ajustarse según sea necesario.
const RAM_MINIMA_GB = 4; // Menos de 4 GB de RAM
const CPU_CORE_MINIMA = 4; // Menos de 4 núcleos de CPU

// Definición de tipo para el navegador con propiedades potencialmente disponibles.
interface PerformanceNavigator {
  deviceMemory?: number;
  hardwareConcurrency?: number;
}

// Función utilitaria independiente para detectar dispositivos de bajos recursos
export const hasLowSpecDevice = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const perfNavigator = navigator as PerformanceNavigator;
  const ram = perfNavigator.deviceMemory;
  const cpuCores = perfNavigator.hardwareConcurrency;

  const lowRam = ram !== undefined && ram < RAM_MINIMA_GB;
  const lowCpu = cpuCores !== undefined && cpuCores < CPU_CORE_MINIMA;

  return lowRam || lowCpu;
};